import React from 'react'
import copy from 'copy-to-clipboard'
import ShareIcon from 'transfix-icons/build/ShareIcon'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { useUserContext } from 'apps/fleet-planner/context/UserContext'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { ContextCard, IconButton, TextField } from 'transfix-ui'

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: 280,
  },
}))

export const BookableShipmentSavedSearchShareTruckContextCard = () => {
  const { trackEvent } = useFMSAnalytics()
  const classes = useStyles()
  const { userData } = useUserContext()
  const { truckAvailabilityShareUuid } = userData || {}
  const sharedLinkUrl = `${__ROOT__}/fms/shared-truck-availability/${truckAvailabilityShareUuid}`
  const copyUrlClickHandler = () => {
    trackEvent('Truck Availability', 'CLICKED_COPY_SHARED_TRUCK_AVAILABILITY_URL_BUTTON')
    copy(sharedLinkUrl)
  }
  return (
    <ContextCard
      contextCardClassName={classes.container}
      button={{
        text: 'Copy Link',
        closeOnClick: true,
        onClick: copyUrlClickHandler,
      }}
      footerText='Those who have access to the link will not be able to edit information'
      hideDottedLines
      triggerText={
        <IconButton Icon={ShareIcon} color='tertiary' onClick={() => undefined} size='large' />
      }>
      <div>
        <Typography variant='body1'>Share your availability</Typography>
        <Typography variant='body2'>
          Copy the link below and share your posted trucks with other shippers or brokers.
        </Typography>
        <Typography variant='body2'>
          Your information will update in realtime as you add or remove trucks.
        </Typography>
        <Box pt={2}>
          <TextField disabled name='sharedLink' value={sharedLinkUrl} onChange={() => undefined} />
        </Box>
      </div>
    </ContextCard>
  )
}
